import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const roleRoutes = {
  admin: '/dashboard/admin',
  agent: '/dashboard/events',
  student: '/dashboard/student-dashboard',
};

const RoleDashboardRedirect = ({ fallback = null }) => {
  const { profile } = useAuth();
  const location = useLocation();
  const userRole = profile?.role ?? null;
  const targetRoute = userRole ? roleRoutes[userRole] : null;

  if (targetRoute && targetRoute !== location.pathname) {
    return <Navigate to={targetRoute} replace />;
  }

  return fallback;
};

export default RoleDashboardRedirect;
